import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://wmczeqzniimmjtsuyykk.supabase.co'
const supabaseAnonKey = 'sb_publishable_30GJA45DOffdMyHs9BOHUQ_Rj_kSsbt'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)